import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { authenticateUserE2E } from '../actions/authenticationJwtActions'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { Formik } from 'formik'
import { TextFieldFormik } from '@sesol-3/gerencial-lib/dist/components/formik/TextFieldFormik'

const mensagemErro = (err) => {
  let mensagem = ''

  if (err) {
    if (err.response.status === 401) {
      mensagem = 'Usuário não autenticado. Informe usuário e senha corretos e tente novamente.'
    } else if (err.response.status === 403) {
      mensagem = 'Usuário não possui perfil para operar o sistema.'
    } else {
      mensagem = err.response
        ? `${err.response.data} ${err.response.status} ${err.response.statusText}`
        : 'Erro ao efetuar login, tente novamente.'
    }
  }

  return mensagem
}

class LoginE2E extends Component {
  onSubmit(values) {
    this.props.authenticateUserE2E({
      username: values.username.trim(),
      password: values.password
    })
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { isUserAuthenticated, err } = this.props.authentication

    if (isUserAuthenticated) {
      return <Redirect to={from} />
    }

    const msgClassName = `form-group ${err ? 'text-danger' : ''}`

    return (
      <Formik initialValues={{ username: '', password: '' }} onSubmit={this.onSubmit.bind(this)}>
        {({ handleSubmit }) => (
          <form className='container form-login' onSubmit={handleSubmit}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
              <Grid item>
                <TextFieldFormik name='username' label='Usuário' variant='standard' />
              </Grid>
              <Grid item>
                <TextFieldFormik name='password' label='Senha' variant='standard' />
              </Grid>
            </Grid>
            <div className={msgClassName}>
              <div className='text-help'>{mensagemErro(err)}</div>
            </div>
            <Button type='submit' id='entrar' className='btn botaoLogar btn-azul'>
              ENTRAR
            </Button>
          </form>
        )}
      </Formik>
    )
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication })

export default connect(mapStateToProps, { authenticateUserE2E })(LoginE2E)
